import React from 'react';
import { CustomAccordion } from '../../../shared';
import Notes from '../../../shared/notes';
import { useSelector } from 'react-redux';
import { successfulEventsList } from './constants';

const SuccessfulEvents = () => {
    const { company } = useSelector(state=> state.company);
    const regenronCompanyList = [140,41,51,53,59,72,90,92];
    const finalList = regenronCompanyList.includes(company.id) ? successfulEventsList['regenronList'] : successfulEventsList.default;
    return(
        <CustomAccordion
            acoordianDetailsBackground='bg-white'
            acoordianDetailsPadding='padding-t-8-b-16'
            component={<Notes Definition={finalList}/>}
            title="Successful Engagement Events"
        />
    );
};

export default SuccessfulEvents;
